import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import cls from 'classnames';

import noop from 'lodash/noop';

import CloserIcon from '@ott/icon-close';

import AutocompleteTrigger from '../../../AutocompleteTrigger/AutocompleteTrigger';

import styles from './MobileHeader.scss';

export default function MobileHeader(props) {
  const { title, ...inputProps } = props;
  const { value, onChange, isLoading } = inputProps;

  const onClear = useCallback(() => {
    onChange('', true);
  }, [onChange]);

  const isClearIconVisible = Boolean(value);

  return (
    <div>
      <div className={styles.inputWrap}>
        <AutocompleteTrigger
          {...inputProps}
          className={styles.input}
          onClick={noop}
          isOpen={true}
          autoFocus={true}
        />
        <div
          className={cls({
            [styles.clearIconWrapper]: true,
            [styles.clearIconWrapperVisible]: isClearIconVisible,
          })}
          onClick={onClear}
        >
          <CloserIcon
            size="normal"
            className={cls({
              [styles.clearIcon]: true,
              [styles.clearIconVisible]: !isLoading,
            })}
          />
        </div>
      </div>
    </div>
  );
}

MobileHeader.defaultProps = {
  name: 'AutocompleteTrigger',
};

MobileHeader.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
